import DoneActivitiesByResponsibleLineChart from "./DoneActivitiesByResponsibleLineChart";

export default DoneActivitiesByResponsibleLineChart;
